import { createFileRoute, redirect } from "@tanstack/react-router";

/** The register moved to HR's front door; the old address still lands. */
export const Route = createFileRoute("/_authenticated/_administration/employees/")({
  beforeLoad: () => {
    throw redirect({ to: "/hr", replace: true });
  },
});
